import Service from "../Service";
const resource = "QaRawMaterialSupplier/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(form, requestID) {
    return Service.post(resource + "save", form, {
      params: { requestID },
    });
  },
};
